import type { AircraftType, FlightKind } from "../state/types";

/** Ключ типа ВС */
export type AircraftTypeKey = "jet" | "regional" | "cargo";

/** Ключ вида рейса */
export type FlightKindKey =
  | "normal"
  | "intl"
  | "cargo"
  | "medevac"
  | "lowfuel"
  | "vip"
  | "connect";

/** Код вымышленной авиакомпании */
export type AirlineCode =
  | "NVR"
  | "BRZ"
  | "SKY"
  | "PLR"
  | "VHR"
  | "LMN"
  | "ZRA"
  | "MRG"
  | "OLS"
  | "KRS"
  | "TYG"
  | "AST";

/**
 * Типы воздушных судов: габариты, очки, обслуживание, скорости.
 */
export const TYPES: Record<AircraftTypeKey, AircraftType> = {
  jet: {
    key: "jet",
    label: "Лайнер",
    len: 52,
    roll: 430,
    pts: 120,
    svc: 15,
    pat: 50,
    spd: 118,
    taxi: 56,
    col: "#4ea3ff",
    pax: 160,
  },
  regional: {
    key: "regional",
    label: "Регионал",
    len: 38,
    roll: 300,
    pts: 80,
    svc: 10,
    pat: 44,
    spd: 104,
    taxi: 64,
    col: "#ffc861",
    pax: 70,
  },
  cargo: {
    key: "cargo",
    label: "Грузовой",
    len: 60,
    roll: 520,
    pts: 170,
    svc: 20,
    pat: 60,
    spd: 100,
    taxi: 48,
    col: "#7ee08a",
    pax: 0,
  },
};

/**
 * Виды рейсов: приоритет ATC и множитель очков.
 */
export const FLIGHT_KINDS: Record<FlightKindKey, FlightKind> = {
  normal: { label: "обычный", prio: 0, pts: 1 },
  intl: { label: "международный", prio: 1, pts: 1.15 },
  cargo: { label: "грузовой", prio: 0, pts: 1.2 },
  medevac: { label: "медрейс", prio: 3, pts: 1.8 },
  lowfuel: { label: "мало топлива", prio: 3, pts: 1.5 },
  vip: { label: "особый рейс", prio: 2, pts: 1.4 },
  connect: { label: "стыковки", prio: 2, pts: 1.25 },
};

/** Коды вымышленных авиакомпаний (не реальные бренды) */
export const AIRLINES: readonly AirlineCode[] = [
  "NVR",
  "BRZ",
  "SKY",
  "PLR",
  "VHR",
  "LMN",
  "ZRA",
  "MRG",
  "OLS",
  "KRS",
  "TYG",
  "AST",
];

/** Отображаемые названия авиакомпаний */
export const AIRLINE_NAME: Record<AirlineCode, string> = {
  NVR: "Невера",
  BRZ: "Бирюза Эйр",
  SKY: "Скайборн",
  PLR: "Поляр",
  VHR: "Вихрелет",
  LMN: "Лумина",
  ZRA: "Заря-Транс",
  MRG: "Мираж",
  OLS: "Ольха",
  KRS: "Кристалл Экспресс",
  TYG: "Тайгалайн",
  AST: "Астравиа",
};
